export default __webpack_public_path__ + "static/media/1912.07e7bed0.png";